import React, {useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import createAxiosInstance from '../axios/axiosCustom'
import debounce from '../utils/debounce'


export default function AutoCompleteAdress(props) {
  const {objKey, className, defaultValue, setValue, disableSearch, name, required, readOnly } = props

  const { t } = useTranslation()
  
  const [display, setDisplay] = useState(false)
  const [search, setSearch] = useState('')
  const [searchChanged, setSearchChanged] = useState(false)
  const [defValue, setDefValue] = useState(defaultValue)
  const [list, setList] = useState([])
  // for clicking outside options to close
  const wrapperRef = useRef(null)
  const srchRef = useRef(false)

  const srchPlaceholder = (disableSearch) ? '' : t('search')+'..'

  const handleClickOutside = event => {
    const { current: wrap } = wrapperRef
    if (wrap && !wrap.contains(event.target)) {
      setDisplay(false)
    }
  }

  const setAdress = (evt) => {
    // console.warn('set', evt)
    setSearch(evt.description)
    setDisplay(false)
    srchRef.current.value = evt.description || evt.main_text

    setValue(evt, objKey)
  } 

  const onClear = (evt) => {
    setDisplay(false)
    setSearch('')
    srchRef.current.value = ''
    
    setValue('', objKey)
  }

  const updateSearch = useCallback(async (event) => {
    let search = event.target.value
    setSearch(search)

    const axiosCustom = await createAxiosInstance()
    let resp = await axiosCustom.post('maps/places', { search: search })
    let data = resp?.data?.data ? resp.data.data.map(item => {
      item.id = item.place_id
      item.name = item.description || item.main_text
      return item
    }) : []

    setList(data)
  }, [])
  
  const debouncedSearch = useCallback(debounce((event) => {
    updateSearch(event)
  }, 500), [updateSearch])

  useEffect(() => {
    if(defaultValue) {
      defaultValue.id = defaultValue.place_id
      defaultValue.name = defaultValue.description || defaultValue.main_text

      setList([defaultValue])
      setDefValue(defaultValue.name)
      setSearch(defaultValue.name)
      srchRef.current.value = defaultValue.name
    }

  }, [defaultValue])

   useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    }
  }, [])


  return (
    <div ref={wrapperRef} className="auto-container">
      <input
        id="autoInput"
        ref={srchRef}
        name={name}
        className={className}
        autoComplete="off"
        onClick={() => {
          if(readOnly) return

          setDisplay(!display); 
          setSearchChanged(true); 
          setSearch('');}}
        placeholder={srchPlaceholder}
        required={required || false}
        readOnly={readOnly || false}
        onChange={debouncedSearch}
      />
      
      {display && (
        <div className="autocomplete-list">
          {list && list
            .map((value, i) => {
              return (
                <div
                onClick={() => setAdress(value)}
                className="autocomplete-option"
                key={value.id || i}
                tabIndex="0"
                >
                  <span>{value.name}</span>
                </div>
              );
            })}
        </div>
      )}
      <span className="bt-clear" onClick={event => onClear(event)} hidden={readOnly ? true : false}>X</span>
    </div>
  )
}
